/**
 * Produktname für sichtbare Texte (Kopf, Tab-Titel, Hinweise). Seit 29.09.2026 „CreatorOffice“.
 * Interne Bezeichner (Paketnamen @talentkontor/*, CSS-Klassen tk-*, Speicherschlüssel tk-*) bleiben unverändert.
 */
export const PLATFORM_NAME = "CreatorOffice";
